import {withTableTitle} from './withTableTitle';
import {TableTitleStyle} from './TableTitleStyle';

/**
 * Optional component to give your data table a title.
 *
 * @component
 */
export const TableTitle = withTableTitle(TableTitleStyle);
